import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import Filter from '@/interfaces/api/Filter';

export default class OrderServiceApi extends ApiService<any> {
  constructor() {
    super('order');
  }

  public orderCsv(param: { from: string; to: string; venue: string; flavor: string; lang?: string }): AxiosPromise {
    return axios.get(`${this.getBaseUrl()}/data/${param.venue}/csv`, { params: param });
  }

  public orderPaymentMethodCsv(param: {
    from: string;
    to: string;
    venue: string;
    flavor: string;
    lang?: string;
    customerGroup?: string;
    labels?: string[];
  }): AxiosPromise {
    return axios.get(`${this.getBaseUrl()}/data/order/csv`, { params: param });
  }

  public testOrder(param: { venue: string }): AxiosPromise<void> {
    return axios.get(`${this.getBaseUrl()}/test/subway/${param.venue}`);
  }

  public orderStatisticsCsv(filter: Filter): AxiosPromise<string> {
    return axios.get(`${this.getBaseUrl()}/data/statistic/csv`, { params: filter });
  }

  public promoCodeOrdersCsv(filter: Filter): AxiosPromise<string> {
    return axios.get(`${this.getBaseUrl()}/data/promoCode/csv`, { params: filter });
  }

  public promoCodeSummaryCsv(filter: Filter): AxiosPromise<string> {
    return axios.get(`${this.getBaseUrl()}/data/promoCode/summary/csv`, { params: filter });
  }

  public exportReport(filter: Filter): AxiosPromise<{ file: string; contentType: string }> {
    return axios.post(`${this.getBaseUrl()}/data/analytics`, filter);
  }

  public downloadReport(data: { file: string; contentType: string }): AxiosPromise<any> {
    if (data.contentType === 'text/csv') {
      return axios.get(`${this.getBaseUrl()}/data/analytics/${data.file}`);
    }

    return axios.get(`${this.getBaseUrl()}/data/analytics/${data.file}`, { responseType: 'arraybuffer' });
  }
}
